import { getProjectIdInfo } from 'owa-timestream-store';
import type { ProjectId } from 'owa-timestream-types';
import findFolder from 'owa-service/lib/findFolder';
import getOutlookSpacesApplicationFolderId from './getOutlookSpacesApplicationFolderId';
import getTargetMailbox from './getTargetMailbox';
import getRequestOptions from './getRequestOptions';

export default async function getAssetsFolderId(projectId: ProjectId) {
    const { outlookSpaceId } = getProjectIdInfo(projectId);

    if (outlookSpaceId) {
        const targetMailbox = getTargetMailbox(projectId);
        const applicationFolderId = await getOutlookSpacesApplicationFolderId(targetMailbox);
        if (applicationFolderId) {
            const assetsFolder = await findFolder(
                applicationFolderId,
                'IPM.ApplicationData',
                'OutlookSpaceAssets' + outlookSpaceId,
                getRequestOptions(targetMailbox)
            );

            if (assetsFolder) {
                return assetsFolder.Id;
            }
        }
    }

    return undefined;
}
